import React from 'react'
import "./overview-card.styles.css"
import Parser from 'html-react-parser'

export default function OverviewCard({url, imgUrl, title, repackSize, ad}) {
    if (url && imgUrl && title && repackSize) {
        return (
            <a href={url}><div className="overview-card" style={{"backgroundImage" : `url(${imgUrl})`}}>
            <div>
                <h2>{title}</h2>
                <p>Repack Size : {repackSize}</p>
            </div>
        </div></a>
        )
    }
    if (ad) {
        return (
            <div className="overview-card" style={{"backgroundImage" : `url(${imgUrl})`}}>
                {
                    Parser(ad)
                }
            </div>
        )
    }
}
